import axios from "axios";
var base64 = require('base-64');
var md5 = require('md5');
import config from "config/index";
let host = config.host+"/api/"
let apikey=config.apikey
// initializing the axios instance with custom configs
const login = function (username,password) {
    let auth = (base64.encode(username+":"+md5(password)))
    return axios.post(host + `Authentication/SignIn`,
        {
            "deviceName": "galaxy s5"
        },
        {
            headers: {
                "Content-Type": "application/json",
                "ApiKey": apikey,
                "Authorization":"Basic "+auth
            }
        }).then((response) => {
            return response.data
        })
}

export default login
  